<template>
  <div>
    <vs-switch color="success" v-model="investmentMechanismEnabled"
      @click.stop="confirmSwitchInvestmentPlanOption('investment_mechanism_enabled', !investmentMechanismEnabled)" />
  </div>
</template>

<script>
export default {
  name: "InvestmentMechanismEnabledButton",
  props: {
    currentInvestmentMechanism: { type: Boolean, default: false},
  },
  mixins: [],
  data() {
    return {
      colClass: "vx-col md:w-1/2 sm:w-full w-full mb-5",
      colClassFull: "vx-col w-full",
      investmentMechanismEnabled: this.currentInvestmentMechanism,
      switchPlanOption: null,
      switchPlanValue: null,
      currentLocation: null,
      locationOptions: {
        enableHighAccuracy: true,
        timeout: Infinity,
        maximumAge: 0
      },
    }
  },
  methods: {
    confirmSwitchInvestmentPlanOption(option, value) {
      let message = "";
      let title = "";
      this.switchPlanOption = option;
      this.switchPlanValue = value;
      // si se va a activar no se muestra mensaje de confirmacion
      if (value) {
        this.switchInvestmentPlanOption();
        return;
      }
      let firstText = value == 1 ? "reactivar" : "pausar";
      let secondText = value == 1 ? "reactivado" : "pausado";
      let thirdText = firstText == "reactivar" ? "pausar" : "reactivar";
      switch (option) {
        case "investment_mechanism_enabled":
          title = "¿Estás seguro que deseas " + firstText + " la compra de participación automática?";
          message = "El proceso será " + secondText + ", lo puedes " + thirdText + " en cualquier momento.";
          break;
        default:
          break;
      }
      this.successDialogWithCallbacks(
        this.switchInvestmentPlanOption,
        () => {
          if (option == "investment_mechanism_enabled") {
            this.investmentMechanismEnabled = !this.investmentMechanismEnabled;
          }
        },
        title,
        message,
        "Confirmar",
        "Cancelar"
      );
    },
    async switchInvestmentPlanOption() {
      this.showLoading(true)
      try {
        let payload = {
          option: this.switchPlanOption,
          value: this.switchPlanValue
        };
        await axios.post(`api/v2/investor/${this.InvestorId}/switchInvestmentPlanOption`, payload);
        this.showLoading(false);
        this.successNotif(
          "Operación exitosa",
          "Se han actualizado exitosamente tus preferencias"
        );
        this.$emit('investment-mechanism-changed', this.switchPlanValue);
      }
      catch (e) {
        const mssg = this.catchError(e);
        this.errorNotif('Error en la operación', mssg);
      }
      this.showLoading(false);
    },
    catchError(e) {
      if (e?.response?.data?.error) {
        return e.response.data.error
      }
      else {
        return "No ha sido posible actualizar la información";
      }
    }
  }
}
</script>

<style scoped>
.vx-card.border-primary {
  border-style: solid;
  border-width: 1px;
}

.checkbox-display {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  justify-content: flex-start;
}
</style>
